
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bestOffers",
      function () {
        return require("private-next-pages/bestOffers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bestOffers"])
      });
    }
  